import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-f8efd3da")

import { ref, onMounted, watch } from "vue";
import KnMarkdown from "@/components/KnMarkdown.vue";
import { findNodesByLabelPath } from "./DocumentationHelper";
import axios from "axios";
import useQuasar from 'quasar/src/composables/use-quasar.js';;
import i18n from "@/App.i18n";


export default _defineComponent({
  expose: [],
  props: {
    path: { type: Array, required: false }
  } as unknown as undefined,
  emits: ["toggle-drawer"] as unknown as undefined,
  setup(__props: { path?: string[] }, { emit }: {
        emit: ({
  (e: "toggle-drawer"): void;
}),
        slots: any,
        attrs: any
      }) {

const props = __props
const { t } = i18n.global;
const $q = useQuasar();

const markdown = ref<string | null>(null);
const folderKey = ref<string | null>(null);





onMounted(async () => {
  await loadMarkdown();
});

watch(
  () => props.path,
  async (newPath, oldPath) => {
    if (newPath !== oldPath) await loadMarkdown();
  }
);

async function loadMarkdown() {
  const folders = ["docs", ...(props.path ? props.path.slice(0, -1) : [])];
  await axios
    .get(process.env.VUE_APP_API_PATH + `2.0/resources/folders`)
    .then((response: any) => {
      const root = Array.isArray(response.data.root) ? response.data.root : Array.isArray(response.data) ? response.data : [];
      const folder = findNodesByLabelPath(root, folders)[0];
      folderKey.value = folder ? folder.key : null;
    })
    .catch(() => {
      folderKey.value = null;
    });

  const fileName = `${props.path ? props.path[props.path.length - 1] : "index.md"}`;
  await axios
    .post(
      process.env.VUE_APP_API_PATH + `2.0/resources/files/download`,
      { key: folderKey.value, selectedFilesNames: [fileName] },
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/zip; charset=utf-8",
        },
      }
    )
    .then((response: any) => {
      markdown.value = response.data;
    });
}

function copyLink() {
  const url = window.location.href;

  navigator.clipboard.writeText(url);
  $q.notify({
    position: "top",
    type: "positive",
    message: t("documentExecution.main.urlCopiedToClipboard"),
  });
}

function toggleDrawer() {
  emit("toggle-drawer");
}

return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")
  const _component_q_tooltip = _resolveComponent("q-tooltip")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_q_btn, {
      round: "",
      flat: "",
      icon: "menu",
      onClick: toggleDrawer,
      class: "drawerButton"
    }),
    _createVNode(_component_q_btn, {
      round: "",
      flat: "",
      icon: "link",
      onClick: copyLink,
      class: "copyButton"
    }, {
      default: _withId(() => [
        _createVNode(_component_q_tooltip, { delay: 500 }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("documentExecution.main.copyLink")), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (markdown.value)
      ? (_openBlock(), _createBlock(KnMarkdown, {
          key: 0,
          source: markdown.value,
          class: "markdownContent"
        }, null, 8, ["source"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})